// Dependencies
import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx'

// Styles
import './Spinner.scss';

class InlineSpinner extends React.Component {
	constructor(props, context) {
		super(props);
		this.state = {
			waiting: true,
		};
		this.waitingTimeMs = props.waitingTimeMs || 200;

		this.style = {
			spinner: {
				backgroundColor: context.themeManager.value('spinner',
					'color', 'fg-color-text-highlight'),
				color: context.themeManager.value('spinner',
					'color', 'fg-color-text-highlight'),
				height: '3em'
			}
		}
	}
	componentDidMount() {
		this.timer = setTimeout(() => {
			this.setState(
				{
					waiting: false,
				},
			);
		}, this.waitingTimeMs);
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	render() {
		if (!this.state.waiting) {
			return (

					<div style={this.style.spinner} className="spinner"/>

			);
		}
		return null;
	}
}
InlineSpinner.contextType = ThemeContext;
const RadiumInlineSpinner = radium(InlineSpinner);
export default (RadiumInlineSpinner);
